import { movies } from "@/mocks/movies";
import MovieCard from "@/components/feature/MovieCard";

export default function FeaturedSection() {
  const featured = movies.filter((m) => m.featured);

  return (
    <section className="px-4 md:px-6 py-10 md:py-14">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h2 className="text-lg md:text-xl font-heading font-bold text-foreground-950">
              热门推荐
            </h2>
            <p className="text-sm text-foreground-500 mt-1">精选高分佳作，不容错过</p>
          </div>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {featured.map((movie) => (
            <MovieCard
              key={movie.id}
              id={movie.id}
              title={movie.title}
              slug={movie.slug}
              category={movie.category}
              year={movie.year}
              rating={movie.rating}
              poster={movie.poster}
              tags={movie.tags}
            />
          ))}
        </div>
      </div>
    </section>
  );
}